/* eslint-disable react/forbid-prop-types */
import { useRef } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../../../juristec-ui/core/Checkbox';
import InputRadio from '../../../juristec-ui/core/InputRadio';
import useOnScreen from '../../../juristec-ui/hooks/useOnScreen';
import TextOverflow from '../../../juristec-ui/core/TextOverflow';

import { OrderRow } from './styled/ControlFilter.styled';

const controlFilterItemDefaultPropHandler = () => {};
const controlFilterItemDefaultPropSelected = [];

const ControlFilterItem = ({
  option, handler = controlFilterItemDefaultPropHandler, selected = controlFilterItemDefaultPropSelected, isRadio = false,
}) => {
  const itemRef = useRef();
  const isVisible = useOnScreen(itemRef);

  return (
    <OrderRow ref={itemRef} className="hover-bgcolor">
      {isVisible ? (
        <>
          {isRadio ? (
            <InputRadio
              value={option.value}
              text={(
                <TextOverflow width={200} fontSize={14}>
                  {option.label}
                </TextOverflow>
              )}
              color="primary"
              variant="outlined"
              selected={selected?.[0]}
              onChange={handler}
              style={{ margin: '0' }}
            />
          ) : (
            <Checkbox
              text={(
                <TextOverflow width={200} fontSize={14}>
                  {option.label}
                </TextOverflow>
              )}
              variant="outlined"
              style={{ width: '100%', justifyContent: 'flex-start' }}
              checked={selected?.includes(option.value)}
              handleCheckboxChange={(check) => handler(check, option.value)}
            />
          )}
        </>
      ) : (<></>)}
    </OrderRow>
  );
};

ControlFilterItem.propTypes = {
  option: PropTypes.objectOf(PropTypes.any).isRequired,
  handler: PropTypes.func,
  selected: PropTypes.arrayOf(PropTypes.any),
  isRadio: PropTypes.bool,
};

export default ControlFilterItem;
